<template>
    <div>
        <div v-if="info">
            <b-form-row v-for="(inf, i) in info" v-bind:key="`info-${i}`">
                <b-col>
                    <b-form-group :label="$t(inf.title)">
                        <b-input-group>
                            <b-form-textarea rows="5" wrap="soft" :formatter="removeHtml"
                                v-model="inf.body"></b-form-textarea>
                            <template #append v-if="showTranslation">
                                <country-flag :country="langcode" size="normal" class="ml-n5" />
                            </template>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-form-row>
        </div>
    </div>
</template>

<script>
import AdminAccessMixin from '@/mixins/AdminAccessMixin';
export default {
    name: 'FormSectionInfo',
    mixins: [AdminAccessMixin],
    props: ["value"],
    components: {
    },
    methods: {
        removeHtml(value) {
            return String(value).replace(/(<([^>]+)>)/ig, "").replace(/<|>/ig, "");
        },
    },
    computed: {
        info: {
            get: function () {
                return this.value
            },
            set: function (value) {
                this.$emit('input', value)
            }
        }
    }
}
</script>

<style lang="scss" scoped></style>